<div class="flex flex-row items-center gap-2.5">
  <div class="flex-[0_2_auto] empty:hidden">
    <ng-content select="[prefix]"></ng-content>
  </div>

  <div class="flex-[1_1_20%]">
    <app-divider></app-divider>
  </div>

  <div class="flex-[0_2_auto] empty:hidden">
    <ng-content select="[suffix]"></ng-content>
  </div>
</div>
